function initialState() {
  return {
    detailsView: "",
    overlappingPane: false,
    Modal: {
      showing: false,
      modalTitle: "",
      group: ""
    },
    customerChat: {
      showing: false,
      recipientName: "",
      recipientId: ""
    },
    pandoChat: false,
    refreshRightNav: 0,
  };
}

const state = initialState();

const getters = {
  detailsView(state) {
    return state.detailsView;
  },
  overlappingPane(state) {
    return state.overlappingPane;
  },
  Modal(state) {
    return state.Modal;
  },
  customerChat(state) {
    return state.customerChat;
  },
  pandoChat(state) {
    return state.pandoChat;
  },
  refreshRightNav(state) {
    return state.refreshRightNav;
  }
};

const actions = {
  setDetailsView(context, detail) {
    context.commit("detailsView", detail);
    if (detail && detail.length > 0) context.dispatch("toggleSideNav", true);
  },
  setOverlappingPane(context, bool) {
    context.commit("setOverlappingPane", bool);
  },
  openModal(context, modal) {
    context.commit("openModal", modal);
  },
  closeModal(context) {
    context.commit("closeModal");
  },
  setCustomerChat(context, details) {
    context.commit("customerChat", details);
  },
  refreshRightNav(context) {
    context.commit("refreshRightNav");
  }
};

const mutations = {
  typeSelected(state, val) {
    state.typeSelected = val;
  },
  detailsView(state, val) {
    state.detailsView = val;
  },
  setOverlappingPane(state, val) {
    state.overlappingPane = val;
  },
  openModal(state, val) {
    state.Modal.modalTitle = val;
    state.Modal.showing = true;
  },
  closeModal(state) {
    let originalState = initialState();
    state.Modal = originalState.Modal;
  },
  customerChat(state, details) {
    state.customerChat = details;
  },
  pandoChat(state, bool) {
    state.pandoChat = bool;
  },
  refreshRightNav(state) {
    state.refreshRightNav++;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/MenuSelector.js